import groupBy from 'lodash/groupBy';
import {getAvailableSizeGroupSizes} from './stock';

function isPlusSize(size) {
  return /^X{2,}/.test(size);
}

function isYouthSize(size) {
  return /^Y/.test(size);
}

export function isExtendedSizeRange(sizes) {
  const groups = groupSizes(sizes.map(s => s.name));
  return (
    (groups.youth && groups.youth.length > 7) ||
    (groups.adult && groups.adult.length > 7)
  );
}

export function conciseSizeName(size) {
  if (isPlusSize(size)) {
    const numberOfXes = size.match(/X/g);
    return size.replace(/^X+/, numberOfXes.length + 'X');
  } else {
    return size;
  }
}

export function groupSizes(sizes) {
  return groupBy(sizes, size => {
    if (isYouthSize(size)) return 'youth';
    return 'adult';
  });
}

export function sizeRange(sizes) {
  return `${conciseSizeName(sizes[0])} - ${conciseSizeName(
    sizes[sizes.length - 1]
  )}`;
}

function sortItemSizesByStyle(items) {
  const styleSizes = {};
  items.forEach(item => {
    if (styleSizes[item.styleId]) {
      const productSize = {};
      productSize[item.productId] = item.sizes;
      let styleSizesForStyle = styleSizes[item.styleId];
      styleSizesForStyle = {...styleSizesForStyle, ...productSize};
      styleSizes[item.styleId] = styleSizesForStyle;
    } else {
      const productSize = {};
      productSize[item.productId] = item.sizes;
      styleSizes[item.styleId] = productSize;
    }
  });
  return styleSizes;
}

/**
 * sort by styleId
 * if single item of style, then pass in only availble size groups
 * if more than 1 item of style,
 *   check if there is ONE with all size groups available,
 *   then all of them get all size groups
 * else,
 *   send only available size groups
 **/
export function getItemSizesToRender(items) {
  const itemSizes = {};
  if (items.length < 2) {
    if (items.length > 0) {
      itemSizes[items[0].productId] = getAvailableSizeGroupSizes(
        items[0].sizes
      );
    }
  } else {
    const itemsByStyle = sortItemSizesByStyle(items);
    Object.keys(itemsByStyle).forEach(style => {
      const colorIdsOfStyle = Object.keys(itemsByStyle[style]);

      if (colorIdsOfStyle.length > 1) {
        let numOfColorsWithAllSizeGroups = 0;
        colorIdsOfStyle.forEach(colorId => {
          getAvailableSizeGroupSizes(itemsByStyle[style][colorId]).length > 1
            ? numOfColorsWithAllSizeGroups++
            : '';
        });
        if (numOfColorsWithAllSizeGroups > 0) {
          colorIdsOfStyle.forEach(colorId => {
            // return only available
            itemSizes[colorId] = itemsByStyle[style][colorId];
          });
        } else {
          colorIdsOfStyle.forEach(colorId => {
            // return only available
            itemSizes[colorId] = getAvailableSizeGroupSizes(
              itemsByStyle[style][colorId]
            );
          });
        }
      } else {
        colorIdsOfStyle.forEach(colorId => {
          // return only available
          itemSizes[colorId] = getAvailableSizeGroupSizes(
            itemsByStyle[style][colorId]
          );
        });
      }
    });
  }
  return itemSizes; // {productId: sizes}
}
